/**
 * Keyboard key constants for event handling across components
 * Provides standardized key identifiers for consistent keyboard interaction
 *
 * @const {Object} keyMap
 * @property {string} ARROW_DOWN - Down arrow key for navigating down in lists/menus
 * @property {string} ARROW_UP - Up arrow key for navigating up in lists/menus
 * @property {string} ENTER - Enter key for submitting forms or selecting items
 * @property {string} ESCAPE - Escape key for closing modals, dropdowns, or canceling actions
 * @property {string} TAB - Tab key for keyboard navigation between elements
 * @property {string} SPACE - Space key for activating buttons or toggling states
 */
export const keyMap = {
    ARROW_DOWN: "ArrowDown",
    ARROW_UP: "ArrowUp",
    ENTER: "Enter",
    ESCAPE: "Escape",
    TAB: "Tab",
    SPACE: " ",
};
